export const sizePerPageList = [
  { text: "10", value: 10 },
  { text: "20", value: 20 },
  { text: "50", value: 50 }
];

export const initialFilter = {
  filter: {
    name: ""
  },
  pageNumber: 1,
  pageSize: 10
};

export const REPORT_ATTACHMENT = {
  evidence_of_transfer: "EVIDENCE_OF_TRANSFER",
  disbursement_form: "DISBURSEMENT_FORM",
  fund_use_plan: "FUND_USE_PLAN",
  prev_month_financial: "PREV_MONTH_FINANCIAL",
  activity_report: "ACTIVITY_REPORT"
};

export const ORGANIZATION_REPORT_STATUS = {
  DRAFT: "DRAFT",
  SUBMIT: "SUBMIT",
  APPROVE: "APPROVE",
  REJECT: "REJECT"
};

export const badge = status => {
  let data = {};
  switch (status) {
    case ORGANIZATION_REPORT_STATUS.DRAFT:
      data = { type: "dark" };
      break;
    case ORGANIZATION_REPORT_STATUS.SUBMIT:
      data = { type: "primary" };
      break;
    case ORGANIZATION_REPORT_STATUS.APPROVE:
      data = { type: "success" };
      break;
      break;
    case ORGANIZATION_REPORT_STATUS.REJECT:
      data = { type: "danger" };
      break;
    default:
      data = { type: "info" };
  }

  return data;
};

export const INIT_ORGANIZATION_REPORT = {
  year: new Date().getFullYear(),
  month: new Date().toLocaleString("id", { month: "numeric" }),
  // zakat: "",
  // infaq: "",
  // alms: "",
  status: ORGANIZATION_REPORT_STATUS.DRAFT,
  bank_name: "",
  bank_account: "",
  bank_account_behalf: ""
};
